module.exports = __webpack_public_path__ + "images/bg-login.8ed9846a81810f62112fe6d060228f6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./img/bg-login.jpg
// module id = 521
// module chunks = 0